import type { VyDate, Optional } from '@vy/utils';
import { vyDate, unix } from '@vy/utils';

export function getDefaultDates(): [VyDate, VyDate] {
  const from = vyDate(undefined, { keepLocalTime: true }).subtract(1, 'day').startOf('day');
  const to = vyDate(undefined, { keepLocalTime: true }).endOf('day');

  return [from, to];
}

export function unixToDayjs(dateStr: Optional<string>) {
  return dateStr ? unix(+dateStr) : undefined;
}

export function convertDateForUrlParams(date: VyDate) {
  return date.unix().toString();
}
